<template>
  <aside class="main-menu-wrapper">
    <div class="main-menu">
      <div class="main-menu-items">
        <div
          v-for="item in items"
          :key="item.path">
          <a
            class="main-menu-item"
            @click="selectMenu(item.path)"
            v-if="item.condition === '' || hasAccess(item.condition)">
            {{item.name}}
          </a>
        </div>

        <a class="main-menu-item" @click="logOut">
          Выход
        </a>
      </div>
    </div>
  </aside>
</template>

<script>
  export default {
    name: "Menu",

    data() {
      return {
        items: [
          { name: 'График приема', path: 'prescriptions', condition: '' },
          { name: 'Назначения', path: 'prescription', condition: '' },
          { name: 'Лист покупок', path: 'shoplist', condition: '' },
          { name: 'Метрики', path: 'checkup', condition: '' },
          { name: 'Статус здоровья', path: 'health', condition: '' },
          { name: 'Заключения', path: 'conclusion', condition: 'conclusion' },
          { name: 'Стратегия', path: 'strategy', condition: '' },
          { name: 'Стиль жизни', path: 'recommendations', condition: '' },
          { name: 'Анкеты', path: 'questionnaire', condition: '' },
          { name: 'Ваша команда', path: 'contacts', condition: '' },
        ],
      };
    },

    computed: {

    },

    methods: {
      hasAccess(view) {
        return this.$store.getters.getFeature(view);
      },

      selectMenu(item) {
        this.$store.dispatch('CHANGE_VIEW', item);
      },

      logOut() {
        try {
          this.$store.dispatch('LOG_OUT');

          this.$store.dispatch('CHANGE_VIEW', 'prescriptions');
        } catch (e) {
          this.$store.dispatch('ERROR', e);
        }
      },
    },
  };
</script>

<style lang="scss">
  @import "../assets/scss/variables";

  .main-menu-wrapper {
      position: fixed;
      z-index: 10000;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

    .main-menu {
      position: relative;
      height: 100%;
      max-width: $max-width;
      margin: 0 auto;
      padding: 250px 0 0;
      background: #1d4322;
      border-bottom: 3px solid $primary;

      .main-menu-items {
        position: absolute;
        top: 50%;
        width: 100%;
        margin-top: -130px;
      }

      .main-menu-item {
        display: block;
        margin: 0 0 20px;
        font-size: 12px;
        font-weight: bold;
        text-align: center;
        text-transform: uppercase;
        color: $white !important;
        text-shadow: 1px 1px 2px $dark;
      }
    }
  }
</style>
